import { render, staticRenderFns } from "./CallPanel.vue?vue&type=template&id=6a5aa284"
import script from "./CallPanel.vue?vue&type=script&lang=js"
export * from "./CallPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports